import * as React from "react";
import { useMemo } from "react";
import { PageInfoProps, DETAIL_TEXT, IconMap } from "./const";

export default (props: PageInfoProps, styles: Record<string, string>) => {
  const {
    icon,
    detail = "",
    actionText = DETAIL_TEXT.actionText,
    type,
    children,
    main = DETAIL_TEXT["somethingWrong"],
    showAction = true,
    detailType,
    renderCustomIcon,
    direction = "vertical",
  } = props;

  const _detailText = useMemo(
    () => detail || DETAIL_TEXT[detailType],
    [detail, detailType]
  );

  const renderIcon = () => {
    if (renderCustomIcon) {
      return renderCustomIcon();
    }
    if (icon) {
      return <img className={styles.img} src={icon} />;
    }
    const showType = type || "error";
    return <div className={styles.icon}>{IconMap[showType]}</div>;
  };

  return (
    <div className={`${styles.bcom_page_info} ${styles[direction] || ""}`}>
      {renderIcon()}
      {main && (
        <div className={`${styles.main} ${styles.overflow} g-font-gt__medium`}>
          {main}
        </div>
      )}
      {_detailText && (
        <div className={`${styles.detail} ${styles.overflow}`}>
          {_detailText}
        </div>
      )}
      {children && <div className={styles.children}>{children || ""}</div>}
      {showAction ? (
        <button
          className={styles.btn}
          onClick={(e) => {
            props.onPress && props.onPress(e);
          }}
        >
          {actionText}
        </button>
      ) : null}
    </div>
  );
};
